<template>
  <div id="cardIndex">
    <div class="tip">
      <div class="process">
        <div class="processList" v-for="(item, i) in processList" :key="i">
          <div v-if="i == 0">
            <div class="process-title">
              <span class="lightLabel">{{ item.num }}</span>
              <div class="title">{{ item.content }}</div>
            </div>
            <img style="width: 170px" src="@/assets/img/solidLine.png" alt="" />
          </div>
          <div v-else>
            <div class="process-title">
              <span class="label">{{ item.num }}</span>
              <div class="title">{{ item.content }}</div>
            </div>
            <img style="width: 170px" src="@/assets/img/line.png" alt="" />
          </div>
        </div>
      </div>
      <div class="ysList">
        <div class="ys" v-for="(i, item) in ysList" :key="item">
          <div class="ys-num">{{ i.num }}</div>
          <div class="ys-title">{{ i.title }}</div>
          <div>{{ i.content }}</div>
        </div>
      </div>
    </div>

    <div class="bankContainer">
      <div
        :class="['bank', item.check ? 'checkBorder' : '']"
        @click.stop="myselect(item)"
        v-for="(item, i) in BankList"
        :key="i"
      >
        <img
          class="isCheck"
          v-if="item.check"
          src="@/assets/img/check.png"
          alt=""
        />
        <img class="isCheck" v-else src="@/assets/img/gray.png" alt="" />
        <div class="bankName">{{ item.name }}</div>
        <img
          :class="[type == 1 ? 'smallImg' : 'bigImg']"
          :src="item.imagePath"
        />
        <div class="content">
          <div class="bankCont">
            {{ item.summary }}
          </div>
        </div>
        <div style="display: flex; justify-content: center">
          <!-- <el-checkbox
            @click.stop.native="() => {}"
            @change="addbank(item)"
            v-model="item.check"
            class="checkbox"
          ></el-checkbox> -->
        </div>
      </div>
      <div :class="['bank']" v-if="BankList.length < 4">
        <!-- <img
            src=""
          /> -->

        <div class="bank-more">
          <i
            style="font-size: 95px; color: #dedede"
            class="el-icon-bank-card"
          ></i>
          <div class="content">
            <div style="text-align: center">更多，敬请期待</div>
            <div class="bankCont"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="btnContainer">
      <div style="width: 380px; position: relative">
        <el-button
          class="confirm-btn"
          @click="confirmingBank"
          v-if="verifyPermission('Add')"
          >选择银行</el-button
        >
        <el-button
          class="content-btn"
          @click="manage"
          v-if="verifyPermission('Select')"
          >开卡记录</el-button
        >
        <slot name="btn"></slot>
      </div>
    </div>
    <!-- <slot name="steps"></slot> -->
  </div>
</template>
<script>
import { verifyPermissionMinix } from "@/utils/mixin";

export default {
  props: {
    ysList: {
      type: Array,
      default() {
        return [];
      },
    },
    processList: {
      type: Array,
      default() {
        return [];
      },
    },
    BankList: {
      type: Array,
      default() {
        return [];
      },
    },
    //卡为1 其他为2
    type: null,
  },
  components: {
    // CardList,
    // businessDescriptionPage,
  },
  mixins: [verifyPermissionMinix],
  data() {
    return {
      operation: "",
      addCustomerDrawerShow: false,
      drawerTitle: "",
      noticeDialogVisible: false,
      fileVisible: false,
      selectVisible: false,
      form: {},
      submitLoading: false,
      rules: {},
      talentList: [],
      tipVisible: false,
      checked: false,
      checkList: {},
      checked1: false,
      checked2: false,
      checked3: false,
      show1: true,
      show2: false,
      show3: false,
      bankInfoList: [],
      //   BankList: [],
      loading: false,
    };
  },
  mounted() {
    // this.getBankList();
    this.userAutoIntId = JSON.parse(
      window.localStorage.getItem("userInfo")
    ).autoIntId;
    this.CompanyAutoIntId = JSON.parse(
      window.localStorage.getItem("CompanyDetail")
    ).autoIntId;
    let _this = this;
    _this.bodyScale();
    window.onresize = function () {
      _this.bodyScale();
    };
  },
  methods: {
    bodyScale() {
      //获取当前分辨率下的可是区域宽度
      var devicewidth = document.documentElement.clientWidth;
      var scale = devicewidth / 1920; // 分母——设计稿的尺寸
      document.getElementById("cardIndex").style.zoom = scale; //放大缩小相应倍数
      console.log(document.getElementById("lin_Search"));
    },
    manage() {
      this.$emit("manage");
    },
    confirmingBank() {
      if (this.bankInfoList.length <= 0) {
        this.$message.error("请选择银行");
        return;
      }
      this.$emit("confirmingBank", this.bankInfoList);

      //   this.show1 = !this.show1;
      //   this.show3 = !this.show3;
      // this.$router.push(
      //   "/businessDescriptionPage?list=" + JSON.stringify(this.bankInfoList)
      // );
    },

    myselect(item) {
      if (this.type != 1) {
        if (item.check == true) {
          this.$set(item, "check", !item.check);
          this.bankInfoList = [];
        } else {
          this.BankList.forEach((item) => {
            item.check = false;
          });
          this.$set(item, "check", !item.check);
          this.bankInfoList = [];
        }
        // item.check = !item.check;
        // this.bankInfoList = [];
        this.BankList.forEach((item) => {
          if (item.check) {
            this.bankInfoList.push({
              bankId: item.bankId,
              bankName: item.bankName,
              sendCC: item.ccEmail,
              sendTo: item.email,
              bankUniqueFlag: item.uniqueFlag,
              type: item.type,
            });
          }
        });
        this.$forceUpdate();
      } else {
        if (item.check == true) {
          this.$set(item, "check", !item.check);
          this.bankInfoList = [];
        } else {
          this.BankList.forEach((item) => {
            item.check = false;
          });
        }
        this.$set(item, "check", !item.check);
        this.bankInfoList = [];
        this.BankList.forEach((item) => {
          if (item.check) {
            this.forBank(item);
          }
        });
        this.$forceUpdate();
      }
    },
    forBank(item) {
      this.bankInfoList.push({
        bankId: item.bankId,
        bankName: item.bankName,
        autoIntId: item.autoIntId,
        bankAutoIntId: item.bankAutoIntId,
        userAutoIntId: this.userAutoIntId,
        bankBusinessId: item.id,
        CompanyAutoIntId: this.CompanyAutoIntId,
        bankUniqueFlag: item.uniqueFlag,
        type: item.type,
      });
    },
    addbank(item) {
      if (this.type != 1) {
        if (item.check == true) {
          // this.$set(item, "check", !item.check);
          this.bankInfoList = [];
        } else {
          this.BankList.forEach((item) => {
            item.check = false;
          });
          // this.$set(item, "check", !item.check);
          this.bankInfoList = [];
        }
        // this.bankInfoList = [];

        this.BankList.forEach((item) => {
          if (item.check) {
            this.bankInfoList.push({
              bankId: item.bankId,
              bankName: item.bankName,
              sendCC: item.ccEmail,
              sendTo: item.email,
              bankUniqueFlag: item.uniqueFlag,
              type: item.type,
            });
          }
        });
      } else {
        this.bankInfoList = [];
        this.BankList.forEach((item) => {
          if (item.check) {
            this.forBank(item);
          }
        });
      }
    },
    singleNot() {
      this.fileVisible = true;
      // this.importVisible = true;
    },
    addPersonnel() {
      if (this.bankInfoList.length <= 0) {
        this.$message.error("请选择银行");
        return;
      }
      this.operation = "add";
      this.addCustomerDrawerShow = true;
      this.drawerTitle = "新增人员开卡";
    },
    resetForm() {},
    notifyCard() {
      if (this.bankInfoList.length <= 0) {
        this.$message.error("请选择银行");
        return;
      }
      this.noticeDialogVisible = true;
    },
  },
};
</script>
<style>
.checkbox {
  zoom: 200%;
}
</style>
<style lang="less" scoped>
.tip {
  display: flex;
  justify-content: space-between;
  .process {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 51px 42px;
    width: 1010px;
    background-color: #feffff;
    box-shadow: 1px 6px 13px 0px #d0d0d0;
    border-radius: 25px;
    margin-right: 30px;
  }
  .processList {
    margin-right: 17px;
    font-size: 14px;
    .process-title {
      display: flex;
      align-items: center;
      .title {
        font-size: 14px;
        margin-left: 11px;
      }
    }
    .lightLabel {
      font-family: Impact;
      font-size: 22px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 20px;
      letter-spacing: 0px;
      color: #457afd;
    }
    .label {
      font-size: 22px;
      font-family: Impact;
      color: #d8d8d8;
    }
  }
  .ysList {
    width: 790px;
    height: 150px;
    background-image: url("../assets/img/ys-bg.png");
    box-shadow: 1px 6px 13px 0px #d0d0d0;
    border-radius: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 30px;
    .ys {
      position: relative;
      width: 177px;
      height: 94px;
      padding-left: 29px;
      color: white;
      border-left: 1px solid #43f1d2;
      margin-right: 15px;
    }
    .ys-title {
      font-size: 18px;
      margin-bottom: 10px;
      margin-top: 10px;
    }
    .ys-num {
      position: absolute;
      left: -9px;
      top: 10px;
      width: 18px;
      height: 18px;
      border-radius: 50%;
      background-color: #43f1d2;
      text-align: center;
      line-height: 18px;
      font-size: 13px;
      color: #457afd;
    }
  }
}
.title {
  font-size: 30px;
  // text-align: center;
  color: #333333;
  font-weight: normal;
}
.btnContainer {
  width: 100%;
  text-align: center;
  position: relative;

  display: flex;
  justify-content: center;
  .confirm-btn {
    width: 120px;
    height: 34px;
    line-height: 10px;
    background-color: #4380fb;
    border-radius: 10px;
    color: white;
  }
  .content-btn {
    width: 120px;
    height: 34px;
    line-height: 10px;
    background-color: #feffff;
    border-radius: 10px;
    border: solid 1px #4380fb;
    color: #4380fb;
  }
}
.bankContainer {
  margin-top: 40px;

  .bank {
    width: 436px;
    background-color: #feffff;
    box-shadow: 1px 6px 13px 0px #d0d0d0;
    border-radius: 25px;
    padding: 23px;
    position: relative;
    .bank-more {
      display: flex;
      height: 100%;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      color: #999999;
      font-size: 16px;
    }
    .isCheck {
      width: 50px;
      height: 50px;
      position: absolute;
      bottom: -2px;
      right: -11px;
    }

    .bigImg {
      width: 330px;
      height: auto;
      margin: 0 10px;
      border: 1px solid rgba(204, 204, 204, 0.443);
      display: block;
      margin: 0 auto;
    }
    .smallImg {
      width: 236px;
      height: auto;
      margin: 0 10px;
      border: 1px solid rgba(204, 204, 204, 0.443);
      display: block;
      margin: 0 auto;
    }
  }
  .span {
    display: flex;
    justify-content: right;
    font-size: 12px;
    margin-top: 10px;
    a {
      text-decoration: underline;
      margin-left: 10px;
      color: inherit;
    }
    a:hover {
      color: #409eff;
    }
  }
}
.bankContainer .bank .content .bankCont {
  height: auto;
  -webkit-line-clamp: 5;
}
</style>